import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MentionsLegales from "../pages/legal/mentions-legales";
import Confidentialite from "../pages/legal/confidentialite";
import CGV from "../pages/legal/cgv";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/confidentialite",
    element: <Confidentialite />,
  },
  {
    path: "/cgv",
    element: <CGV />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
